import { createBrowserRouter } from 'react-router-dom';
import HomeContainer from './features/home/HomeContainer';
import Login from './features/auth/LoginContainer';
import VerifyUser from './features/auth/VerifyUserContainer';
import SelfAuth from './features/auth/SelfAuthContainer';
import NotFound from './screens/NotFound';
import PrivateRoute from './screens/privateRoute';
import CompanyKPIContainer from './features/kpi/CompanyKPIContainer';
import IndividualDetailsContainer from './features/kpi/IndividualDetailsContainer';
import AudioBooksAllocationContainer from './features/kpi/AudioBooksAllocationContainer';
import CampaignAndChannelContainer from './features/kpi/CampaignAndChannelContainer';
import CampaignDetailsContainer from './features/kpi/CampaignDetailsContainer';
import AudioBooksDetailsContainer from './features/kpi/AudioBookDetailsContainer';
import KPIDumpContainer from './features/kpi/KPIDumpContainer';
import ContentRatingQualityContainer from './features/kpi/ContentRatingQualityContainer';

export default createBrowserRouter([
  {
    path: '/',
    element: <HomeContainer />,
  },
  {
    path: '/auth',
    element: <Login />,
  },
  {
    path: '/verifyUser',
    element: <VerifyUser />,
  },
  {
    path: '/self',
    element: <SelfAuth />,
  },
  {
    path: '/overview',
    element: (
      <PrivateRoute>
        <CompanyKPIContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/overview/details',
    element: (
      <PrivateRoute>
        <IndividualDetailsContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/audio-books-allocation',
    element: (
      <PrivateRoute>
        <AudioBooksAllocationContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/audio-books/:bookName',
    element: (
      <PrivateRoute>
        <AudioBooksDetailsContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/campaign-and-channels',
    element: (
      <PrivateRoute>
        <CampaignAndChannelContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/campaign-details/:campaign',
    element: (
      <PrivateRoute>
        <CampaignDetailsContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/kpi-data-dump',
    element: (
      <PrivateRoute>
        <KPIDumpContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/kpi-data-dump/:id',
    element: (
      <PrivateRoute>
        <KPIDumpContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/content-rating-quality',
    element: (
      <PrivateRoute>
        <ContentRatingQualityContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
